<template>
	<div>
		<!-- 路由导航 -->
		<div class="routerDh f-bct">
			<div class="l f-ct">
				<div class="t1" @click="back()">当前位置：发票管理</div>
				<el-image :src="require('@/static/icon55.png')"></el-image>
				<div class="t2">查看开票详情</div>
			</div>
			<div class="r f-ct" @click="back()">
				<div class="t2">返回开票信息</div>
				<el-image :src="require('@/static/icon56.png')"></el-image>
			</div>
		</div>
		<!-- 表单 -->
		<div class="conBox animate__animated animate__fadeIn" data-wow-duration="0.8s">
			<div class="fpMsg">
				<div class="status" v-if="pmsg.status==0">发票状态：待提交</div>
				<div class="status" v-if="pmsg.status==1">发票状态：待审核</div>
				<div class="status" v-if="pmsg.status==2">发票状态：已审核</div>
				<div class="status" v-if="pmsg.status==3">发票状态：已开票</div>
				<div class="msgBox">
					<div class="itm">
						<p class="t1">培训课程</p>
						<p class="t2">{{pmsg.courseName}}</p>
					</div>
					<div class="itm">
						<p class="t1">发票类型</p>
						<p class="t2" v-if="pmsg.grantType==1">电子发票</p>
						<p class="t2" v-if="pmsg.grantType==2">纸质发票</p>
					</div>
					<div class="itm">
						<p class="t1">发票票种</p>
						<p class="t2" v-if="pmsg.invoiceType==1">普通发票(个人)</p>
						<p class="t2" v-if="pmsg.invoiceType==2">普通发票(单位)</p>
						<p class="t2" v-if="pmsg.invoiceType==3">专用发票(单位)</p>
					</div>
					<div class="itm">
						<p class="t1">开票抬头</p>
						<p class="t2">{{pmsg.title}}</p>
					</div>
					<template v-if="pmsg.invoiceType==1">
						<!-- <div class="itm">
							<p class="t1">姓名</p>
							<p class="t2">{{pmsg.name}}</p>
						</div> -->
						<div class="itm">
							<p class="t1">邮箱</p>
							<p class="t2">{{pmsg.email}}</p>
						</div>
					</template>
					<template v-if="pmsg.invoiceType==2">
						<!-- <div class="itm">
							<p class="t1">单位名称</p>
							<p class="t2">{{pmsg.name}}</p>
						</div> -->
						<div class="itm">
							<p class="t1">纳税人识别号</p>
							<p class="t2">{{pmsg.code}}</p>
						</div>
						<div class="itm">
							<p class="t1">邮箱</p>
							<p class="t2">{{pmsg.email}}</p>
						</div>
					</template>
					<template v-if="pmsg.invoiceType==3">
						<!-- <div class="itm">
							<p class="t1">单位名称</p>
							<p class="t2">{{pmsg.name}}</p>
						</div> -->
						<div class="itm">
							<p class="t1">纳税人识别号</p>
							<p class="t2">{{pmsg.code}}</p>
						</div>
						<div class="itm">
							<p class="t1">单位地址</p>
							<p class="t2">{{pmsg.address}}</p>
						</div>
						<div class="itm">
							<p class="t1">单位联系电话</p>
							<p class="t2">{{pmsg.mobile}}</p>
						</div>
						<div class="itm">
							<p class="t1">开户行</p>
							<p class="t2">{{pmsg.openingBank}}</p>
						</div>
						<div class="itm">
							<p class="t1">银行账号</p>
							<p class="t2">{{pmsg.bankAccount}}</p>
						</div>
					</template>
					<div class="itm">
						<p class="t1">开票金额</p>
						<p class="t2">¥{{pmsg.invoiceMoney}}</p>
					</div>
					<div class="itm" v-if="pmsg.courseOrder">
						<p class="t1">关联订单</p>
						<p class="t2">{{pmsg.courseOrder.orderNo}}</p>
					</div>
					<div class="itm">
						<p class="t1">申请时间</p>
						<p class="t2">{{pmsg.createTime}}</p>
					</div>
					<div class="itm">
						<p class="t1">发票状态</p>
						<p class="t2" v-if="pmsg.status==0">待提交</p>
						<p class="t2" v-if="pmsg.status==1">待审核</p>
						<p class="t2" v-if="pmsg.status==2">已审核</p>
						<p class="t2" v-if="pmsg.status==3">已开票<span>请及时前往中心前台领取发票，或联系中心老师邮寄发票</span></p>
					</div>
					<div class="itm" v-if="pmsg.grantType==1&&pmsg.status==3">
						<p class="t1">电子发票</p>
						<div class="img" @click="wlLink(pmsg.invoiceUrl)">
							<el-image :src="pmsg.invoiceUrl"></el-image>
						</div>
					</div>
				</div>
			</div>
			<div class="pageAnniuBox f-ct">
				<div class="b2" @click="back()">返回</div>
			</div>		
		</div>
	</div>
</template>
<script>
import { memberInvoiceorderInvoiceDetail,
memberInvoiceorderInvoiceDetailC
} from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			id:'',
			pmsg:'',
		}
	},
	mounted() {
		// 参数
		this.id = this.$route.query.id
		this.memberInvoiceorderInvoiceDetail()
	},
	methods:{
		async memberInvoiceorderInvoiceDetail(){
			let res;
			if(this.userType==1){
				res = await memberInvoiceorderInvoiceDetail({id:this.id});
			}
			if(this.userType==2){
				res = await memberInvoiceorderInvoiceDetailC({id:this.id});
			}
			if(res.code==200){
				this.pmsg = res.data
			}else{this.Tips(res.msg,'error')}
		},
	},
	computed:{
		...mapState('userMsg',['userInfo','userType']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.routerDh{
	margin: 0 40px;
	margin-bottom: 24px;
	.l{
		.t1{
			font-size: 16px;
			color: #9A9DA7;
			cursor: pointer;
		}
		.el-image{
			width: 16px;
			height: 16px;
			margin: 0 2px;
		}
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
	}
	.r{
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
		.el-image{
			width: 18px;
			height: 18px;
			margin-left: 6px;
		}
	}
}
.conBox{
	margin: 0 40px;
	background: #fff;
	border-radius: 20px;
	padding: 0 32px;
	padding-bottom: 40px;
	padding-top: 32px;
	.pageAnniuBox{
		margin-top: 32px;
		div{
			width: 148px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			padding: 0 26px;
			margin-right: 24px;
			cursor: pointer;
		}
		.b2{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b1{
			background: #3B6492;
			color: #fff;
			
		}
	}
	.status{
		width: 100%;
		background: #3B6492;
		height: 48px;
		display: flex;
		align-items: center;
		padding: 0 25px;
		font-size: 18px;
		color: #FFFFFF;
		// margin-top: 32px;
	}
	.msgBox{
		padding: 0 24px;
		padding-top: 24px;
		background: #FBFCFF;
		border: 1px solid #EBF0FC;
		border-top: none;
		padding-bottom: 24px;
		.itm{
			margin-bottom: 16px;
			display: flex;
			.t1{
				width: 116px;
				font-size: 16px;
				color: #9A9DA7;
			}
			.t2{
				font-size: 16px;
				width: calc(100% - 116px);
				span{
					font-size: 14px;
					color: #FF5F5A;
					padding-left: 8px;
				}
			}
			.img{
				.el-image{
					width: 202px;
					height: 122px;
				}
			}
		}
	}
	
}
</style>